import { Box, styled } from '@mui/material';

const DateNavigation = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.6rem',
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'center',
  },
  [theme.breakpoints.down('lg')]: {
    justifyContent: 'flex-end',
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

const ViewModes = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

const CalendarBody = styled(Box)(() => ({
  width: '100%',
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  padding: 0,
  marginLeft: 0,
  marginRight: 0,
  marginBottom: 0,
}));

const CalendarHeader = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xl')]: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 2fr',
  },
  [theme.breakpoints.down('xl')]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('xl')]: {
    gap: '1.125rem',
  },
  [theme.breakpoints.down('xl')]: {
    gap: '0.825rem',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
}));

export { DateNavigation, CalendarBody, CalendarHeader, ActionsContainer, ViewModes };
